import { useImperativeHandle, useRef, type Ref, type RefObject } from 'react'

export function useDOMRef<T extends HTMLElement = HTMLElement>(ref?: RefObject<T | null> | Ref<T | null>) {
  const domRef = useRef<T>(null)

  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- ref bridge
  useImperativeHandle(ref, () => domRef.current as T)

  return domRef
}
